// extracted by mini-css-extract-plugin
export default {"sidebar":"AccountSettingsSidebar_sidebar__FO4u+","tabButton":"AccountSettingsSidebar_tabButton__eqI7i","active":"AccountSettingsSidebar_active__L0cxP"};